import React, { Component } from "react";
import _ from "lodash";
import { groupItemsByStation } from "../../utils/Helpers";

const PriceCell = ({ item }) => {
  return (
    <td className="hidden-xs-down">
      <div className="d-flex align-items-center">
        <div className="d-flex">{item.price}</div>
      </div>
    </td>
  );
};

const Inventory = ({ inventoriesCount }) => {
  return (
    <td>
      <div className="d-flex align-items-center">
        <div className="d-flex">{inventoriesCount}</div>
      </div>
    </td>
  );
};

const ActionCell = ({ handleEditItem, handleDeleteItem }) => {
  return (
    <td>
      <span className="d-flex">
        <button className="mr-05 btn-sm btn-primary btn" onClick={handleEditItem}>
          <i className="fa fa-pencil"></i>
        </button>
        <button className="mr-05 btn-sm btn btn-danger" onClick={handleDeleteItem}>
          <i className="fa fa-trash"></i>
        </button>
      </span>
    </td>
  );
};

const CreateLabelCell = ({ item, handleCreateLabels }) => {
  return (
    <td>
      <span className="d-flex flex-column-768">
        {item.has_info_barcodes && (
          <button className="mr-05 btn-sm btn btn-primary btn mb-1 mb-sm-0" onClick={() => handleCreateLabels(item, true)}>
            <i className="fa fa-barcode"></i>
          </button>
        )}
        <button className="mr-05 btn-sm btn btn-primary btn" onClick={() => handleCreateLabels(item, false)}>
          <i className="fa fa-edit"></i>
        </button>
      </span>
    </td>
  );
};

const TemperatureCell = ({ item, status, temperature, handleTemperatureSubmit }) => {
  return status === 2 ? (
    <td>{temperature ? temperature : "-"}</td>
  ) : (
    <td>
      <div className="mr-05 row">
        <input
          type="number"
          id={`temperature-${item.id}`}
          name={`temperature-${item.id}`}
          className="form-control"
          placeholder="Enter temperature"
          defaultValue={temperature}
          onBlur={(e) => handleTemperatureSubmit(item, e.target.value)}
        />
      </div>
    </td>
  );
};

const Item = ({
  item,
  status,
  handleEditItem,
  handleDeleteItem,
  showActionColumn,
  showTemperatureColumn,
  handleTemperatureSubmit,
  showCreateLabelColumn,
  showInventoriesColumn,
  inventories,
  handleCreateLabels,
}) => {
  const temperature = item.temperature ? item.temperature : "";
  return (
    <tr>
      <td>{item ? item.name : ""}</td>
      <td>{item.brand ? item.brand.brand_name : "-"}</td>
      <td className="hidden-xs-down">
        <b>{item.quantity}</b>
        <span className="ml-05 badge badge-pill badge-info">{item.presentation ? item.presentation : "Case"}</span>
      </td>
      <td>{item.grade ? item.grade.grade : "N/A"}</td>
      <td className="hidden-xs-down">{item.number_items}</td>
      <PriceCell item={item} />
      {showTemperatureColumn && (
        <TemperatureCell item={item} status={status} temperature={temperature} handleTemperatureSubmit={handleTemperatureSubmit} />
      )}
      {showInventoriesColumn && <Inventory inventoriesCount={inventories} />}
      {showCreateLabelColumn && <CreateLabelCell item={item} handleCreateLabels={handleCreateLabels} />}
      {showActionColumn && <ActionCell handleEditItem={handleEditItem} handleDeleteItem={handleDeleteItem} />}
    </tr>
  );
};

const Label = ({ item, label }) => {
  return (
    <tr>
      <td>{item ? item.name : ""}</td>
      <td>{item.brand ? item.brand.brand_name : "-"}</td>
      <td>{label.number_inventories}</td>
      <td className="hidden-xs-down">{label.weight}</td>
      <td>{item.grade ? item.grade.grade : "N/A"}</td>
      <td className="hidden-xs-down">{item.number_items}</td>
      <td className="hidden-xs-down">{label.price}</td>
      <td>{item.temperature ? item.temperature : " - "}</td>
      <td>{label.vendor_lot_number}</td>
      <td>{label.packing_date}</td>
    </tr>
  );
};

export default class PurchaseOrderDetail extends Component {
  render() {
    const itemsByStation = groupItemsByStation(this.props.purchaseOrder.items);
    const status = this.props.purchaseOrder.status;
    const isFromInvoice = this.props.isFromInvoice;
    const showLabels = status === 2;
    const showActionColumn = status === 0 || (status === 1 && !isFromInvoice);
    const showTemperatureColumn = (status === 1 && isFromInvoice) || status === 2;
    const showCreateLabelColumn = status === 1 && isFromInvoice;
    const showInventoriesColumn = status === 1 && isFromInvoice;
    return (
      <div>
        {Object.keys(itemsByStation).map((station) => {
          return (
            <div key={station} className="card">
              <div className="card-block p-0 overflow-scroll">
                <table className="table table-striped table-order-station datatable mb-0">
                  <thead className="thead-inverse">
                    <tr className="table-section-header">
                      <td>{station}</td>
                    </tr>
                    <tr>
                      <th>Item</th>
                      <th>
                        <span className="hidden-xs-down">Manufacturer</span>
                        <span className="hidden-sm-up">Mfr.</span>
                      </th>
                      {showLabels && <th>Num. inventories</th>}
                      <th className="hidden-xs-down">Qty</th>
                      <th>Grade</th>
                      <th className="hidden-xs-down">Pieces</th>
                      <th className="hidden-xs-down">Unit Price</th>
                      {showTemperatureColumn && (
                        <th>
                          <span className="hidden-xs-down">Temperature</span>
                          <span className="hidden-sm-up">Temp.</span>
                        </th>
                      )}
                      {showInventoriesColumn && (
                        <th>
                          <span className="hidden-xs-down">Inventories</span>
                          <span className="hidden-sm-up">Inv.</span>
                        </th>
                      )}
                      {showCreateLabelColumn && <th>Create Labels</th>}
                      {showActionColumn && <th>Actions</th>}
                      {showLabels && <th>Vendor Lot Number</th>}
                      {showLabels && <th>Packing date</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {itemsByStation[station].map((item, index) => {
                      if (!showLabels) {
                        return (
                          <Item
                            item={item}
                            key={`item-${index}`}
                            status={status}
                            handleEditItem={() => this.props.handleEditItem(item)}
                            handleDeleteItem={() => this.props.handleDeleteItem(item.id)}
                            showActionColumn={showActionColumn}
                            showTemperatureColumn={showTemperatureColumn}
                            showCreateLabelColumn={showCreateLabelColumn}
                            showInventoriesColumn={showInventoriesColumn}
                            handleTemperatureSubmit={this.props.handleTemperatureSubmit}
                            inventories={item.labels.reduce((acc_label, label) => acc_label + label.number_inventories, 0)}
                            handleCreateLabels={this.props.handleCreateLabels}
                          />
                        );
                      } else {
                        return item.labels.map((label) => <Label item={item} label={label} key={`label-${label.id}`} />);
                      }
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}
